module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=BA - Bosnia and Herzegovina.a632dcc5.svg";